import styled from 'styled-components'
import { Table } from "../../../../components/ui/Table";

export const TwoColuns = styled(Table.Item)`
  grid-column: span 2 / span 2;
`
